import * as React from 'react';
import Amex from './icons/amex.svg';
import Discover from './icons/discover.svg';
import Maestro from './icons/maestro.svg';
import MasterCard from './icons/mastercard.svg';
import Paypal from './icons/paypal.svg';
import Visa from './icons/visa.svg';
import Warning from './icons/warning.svg';
import Default from './icons/default.svg';

interface PaymentIconsProps {
  /** Name of an icon */
  name: Name;
  className?: string;
  /** Wrapper styles */
  style?: React.CSSProperties;
  // For accessibility
  title?: string;
  alt?: string;
}

export enum Name {
  amex = 'amex',
  discover = 'discover',
  maestro = 'maestro',
  masterCard = 'mastercard',
  paypal = 'paypal',
  visa = 'visa',
  warning = 'warning',
  default = 'default',
}

export const SUPPORTED_CARDS_ICONS = [
  Name.amex,
  Name.visa,
  Name.masterCard,
  Name.maestro,
  Name.discover,
];

const mapNamesToStandaloneSVGS: { [name in Name]: string } = {
  amex: Amex,
  discover: Discover,
  maestro: Maestro,
  mastercard: MasterCard,
  paypal: Paypal,
  visa: Visa,
  warning: Warning,
  default: Default,
};

export const PaymentIcon = ({
  name,
  className,
  style,
  title,
  alt,
}: PaymentIconsProps): JSX.Element | null => {
  return mapNamesToStandaloneSVGS[name] ? (
    <img
      src={mapNamesToStandaloneSVGS[name]}
      className={className}
      style={style}
      aria-label={title}
      alt={alt}
    />
  ) : null;
};
